import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import { useFullPageData } from "@/common/Contexts/FullPageContext";
import Layout from "@/_LayoutsRelated/layout/Layout";
import TextImageComponent from "@/pages/about-us/AboutUsComponents/components/TextImageComponent/TextImageComponent";
import stl from "@/pages/financing/Financing.module.css";
import BanksGroup from "@/pages/landingPages/components/section__BanksGroup/BanksGroup";
import { useLang } from "@/common/Contexts/LanguageContext";
import BreadCrumb from "@componentsShared/BreadCrumb";
import BenefitsList from "@/pages/financing/FinancingComponents/BenefitsList/BenefitsList";
import WhyFinancing from "@/pages/financing/FinancingComponents/WhyFinancing/WhyFinancing";
import CarMakeContainer from "@/pages/landingPages/components/CarMakeContainer/CarMakeContainer";
import Banner from "@componentsShared/Banner/Banner";
import FinanceBanks, { FullBanksList } from "@/pages/financing/financingBanks/FinanceBanks";
import FinancingMakeModel, { BrowseCarsByYears, FinanceDetailsTable, TwoColumnsBulletedList } from "@/pages/financing/financingMakeModel/FinancingMakeModel";
import FinancingMake from "@/pages/financing/financingMake/FinancingMake";
import FinanceLanding, { FinanceLandingHero } from "@/pages/financing/FinancingLanding/FinancingLanding";
import { financeButtonColorHelper, financeImageHelper, financeTranslateText, financeUrlHelper } from "@/pages/financing/helpers/financingHelpers";
import ButtonLink from "@/components/UiKit/Button/ButtonLink";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { PageNamesEnum } from "@/routes/routes";
import { ComponentType } from "@type/models/cms";
import BrowseCarsBy from "@/pages/landingPages/components/sections__BrowseCarsBy/BrowseCarsBy";
import AnyQustV2 from "@/pages/homePageV2/homePageComponents/components/AnyQust/AnyQustV2";
var HeaderPanel = function HeaderPanel(_ref) {
  var h1_title = _ref.h1_title,
    subtitle = _ref.subtitle,
    align = _ref.align,
    breadcrumb = _ref.breadcrumb,
    make = _ref.make,
    model = _ref.model;
  align === "center" ? stl.finance2ndPageBanner : stl.finance2ndPageBannerLeft;
  var lang = useLang();
  return /*#__PURE__*/React.createElement(Banner, {
    className: stl.finance2ndPageBanner
  }, /*#__PURE__*/React.createElement("div", null, breadcrumb && /*#__PURE__*/React.createElement("div", {
    className: "BreadcrumbGeneric"
  }, /*#__PURE__*/React.createElement(BreadcrumbGeneric, {
    breadcrumb: breadcrumb,
    make: make,
    model: model
  })), /*#__PURE__*/React.createElement("h1", null, financeTranslateText(h1_title, make, model, lang)), /*#__PURE__*/React.createElement("p", null, financeTranslateText(subtitle, make, model, lang))));
};
var BrowseCarsBy__internal = function BrowseCarsBy__internal(_ref2) {
  var make = _ref2.make,
    model = _ref2.model,
    carsSearchResults = _ref2.carsSearchResults,
    title = _ref2.title,
    cta = _ref2.cta,
    number_of_cars = _ref2.number_of_cars;
  var lang = useLang();
  title = financeTranslateText(title, make, model, lang);
  var url = financeUrlHelper(cta.url, lang, make, model);
  return /*#__PURE__*/React.createElement(BrowseCarsBy, {
    title: title,
    url: url,
    cta: cta,
    products: carsSearchResults,
    number_of_cars: number_of_cars
  });
};
var ButtonLinkContainer = function ButtonLinkContainer(_ref3) {
  var type = _ref3.type,
    url = _ref3.url,
    newTab = _ref3.newTab,
    text = _ref3.text,
    make = _ref3.make,
    model = _ref3.model;
  var lang = useLang();
  var style = {
    backgroundColor: financeButtonColorHelper(type)
  };
  return /*#__PURE__*/ /*below div has centered content*/React.createElement("div", {
    className: "m-hide",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(ButtonLink, {
    style: style,
    newTab: newTab,
    link: financeUrlHelper(url, lang, make, model)
  }, text));
};
var BenefitsListWrapper = function BenefitsListWrapper(_ref4) {
  var make = _ref4.make,
    model = _ref4.model,
    reverse = _ref4.reverse,
    title = _ref4.title,
    image = _ref4.image,
    points = _ref4.points,
    loading = _ref4.loading;
  var lang = useLang();
  return /*#__PURE__*/React.createElement(BenefitsList, {
    title: financeTranslateText(title, make, model, lang),
    benefits: points.map(function (point) {
      return financeTranslateText(point.text, make, model, lang);
    }),
    image: financeImageHelper(image.url),
    reversed: reverse,
    loading: loading
  });
};
var BrowseFinancing = function BrowseFinancing(_ref5) {
  var make = _ref5.make,
    model = _ref5.model,
    makes = _ref5.makes,
    models = _ref5.models,
    title = _ref5.title,
    link_base_path = _ref5.link_base_path,
    cta = _ref5.cta;
  var lang = useLang();
  return /*#__PURE__*/React.createElement(CarMakeContainer, {
    showAsListOnMobile: true,
    title: financeTranslateText(title, make, model, lang),
    carMakesOrModelOrYears: models.length > 0 ? models : makes,
    cta: cta,
    selectedMake: make,
    selectedModel: model,
    link_base_path: link_base_path,
    models: models
  });
};
var ProcessSteps = function ProcessSteps(_ref6) {
  var make = _ref6.make,
    model = _ref6.model,
    title = _ref6.title,
    subtitle = _ref6.subtitle,
    points = _ref6.points;
  var lang = useLang();
  return /*#__PURE__*/React.createElement(WhyFinancing, {
    title: financeTranslateText(title, make, model, lang),
    description: financeTranslateText(subtitle, make, model, lang),
    points: points.map(function (point) {
      return {
        text: financeTranslateText(point.text, make, model, lang),
        icon: financeImageHelper(point.icon.url)
      };
    })
  });
};
var BanksGroup__internal = function BanksGroup__internal(_ref7) {
  var title = _ref7.title,
    cta = _ref7.cta,
    banks = _ref7.banks;
  return /*#__PURE__*/React.createElement(BanksGroup, {
    title: title,
    cta: cta,
    banks: banks
  });
};
var AboutSyarah = function AboutSyarah(_ref8) {
  var textContent = _ref8.textContent,
    title = _ref8.title,
    image = _ref8.image;
  return /*#__PURE__*/React.createElement(TextImageComponent, {
    title: title,
    image: financeImageHelper(image.url),
    content: [{
      text: textContent,
      isBullet: false
    }],
    revRow: false,
    className: stl.textImageMargins
  });
};
var NeedHelp = function NeedHelp() {
  return /*#__PURE__*/React.createElement(AnyQustV2, null);
};
var BreadcrumbGeneric = function BreadcrumbGeneric(_ref9) {
  var breadcrumb = _ref9.breadcrumb,
    make = _ref9.make,
    model = _ref9.model;
  var lang = useLang();
  var extraLinks = [];
  if (breadcrumb.label1) {
    extraLinks.push({
      link: financeUrlHelper(breadcrumb.link1, lang, make, model),
      title: financeTranslateText(breadcrumb.label1, make, model, lang)
    });
  }
  if (breadcrumb.label2) {
    extraLinks.push({
      link: financeUrlHelper(breadcrumb.link2, lang, make, model),
      title: financeTranslateText(breadcrumb.label2, make, model, lang)
    });
  }
  if (breadcrumb.label3) {
    extraLinks.push({
      link: financeUrlHelper(breadcrumb.link3, lang, make, model),
      title: financeTranslateText(breadcrumb.label3, make, model, lang)
    });
  }
  return /*#__PURE__*/React.createElement(BreadCrumb, {
    hasSchemaOrg: true,
    className: stl.brdCrmb,
    links: [].concat(extraLinks)
  });
};
export var renderHeadlessComponent = function renderHeadlessComponent(financePageResponse, section) {
  var cheapestCarPriceDetails = financePageResponse.cheapestCarPriceDetails,
    selectedMake = financePageResponse.selectedMake,
    selectedModel = financePageResponse.selectedModel,
    carsSearchResults = financePageResponse.carsSearchResults,
    makes = financePageResponse.makes,
    models = financePageResponse.models;
  switch (section.__component) {
    case ComponentType.HERO:
      return /*#__PURE__*/React.createElement(FinanceLandingHero, section);
    case ComponentType.HEADER_PANEL:
      return /*#__PURE__*/React.createElement(HeaderPanel, _extends({}, section, {
        make: selectedMake,
        model: selectedModel
      }));
    case ComponentType.FINANCE_DETAILS:
      return /*#__PURE__*/React.createElement(FinanceDetailsTable, _extends({}, section, {
        make: selectedMake,
        model: selectedModel,
        cheapestCarPriceDetails: cheapestCarPriceDetails
      }));
    case ComponentType.BUTTON_LINK:
      return /*#__PURE__*/React.createElement(ButtonLinkContainer, _extends({}, section, {
        make: selectedMake,
        model: selectedModel
      }));
    case ComponentType.BROWSE_CARS:
      return /*#__PURE__*/React.createElement("div", {
        className: stl.BrowseCarsBy_container
      }, /*#__PURE__*/React.createElement(BrowseCarsBy__internal, _extends({}, section, {
        carsSearchResults: carsSearchResults,
        make: selectedMake,
        model: selectedModel
      })));
    case ComponentType.BENEFITS_LIST:
      return /*#__PURE__*/React.createElement(BenefitsListWrapper, _extends({}, section, {
        make: selectedMake,
        model: selectedModel
      }));
    case ComponentType.TWO_COLUMNS_LIST:
      return /*#__PURE__*/React.createElement(TwoColumnsBulletedList, _extends({}, section, {
        make: selectedMake,
        model: selectedModel
      }));
    case ComponentType.BROWSE_FINANCING:
      return /*#__PURE__*/React.createElement(BrowseFinancing, _extends({}, section, {
        makes: makes,
        models: models,
        make: selectedMake,
        model: selectedModel
      }));
    case ComponentType.BROWSE_CARS_BY_YEARS:
      return /*#__PURE__*/React.createElement(BrowseCarsByYears, _extends({}, section, {
        make: selectedMake,
        model: selectedModel
      }));
    case ComponentType.PROCESS_STEPS:
      return /*#__PURE__*/React.createElement(ProcessSteps, _extends({}, section, {
        make: selectedMake,
        model: selectedModel
      }));
    case ComponentType.BANKS_GROUP:
      return /*#__PURE__*/React.createElement(BanksGroup__internal, section);
    case ComponentType.ABOUT_SYARAH:
      return /*#__PURE__*/React.createElement(AboutSyarah, section);
    case ComponentType.NEED_HELP:
      return /*#__PURE__*/React.createElement(NeedHelp, section);
    case ComponentType.FULL_BANKS_LIST:
      return /*#__PURE__*/React.createElement(FullBanksList, section);
    case ComponentType.BREADCRUMB:
      return /*#__PURE__*/React.createElement("div", {
        className: stl.BreadcrumbGeneric2
      }, /*#__PURE__*/React.createElement("div", {
        className: "BreadcrumbGeneric"
      }, /*#__PURE__*/React.createElement(BreadcrumbGeneric, {
        breadcrumb: section,
        make: selectedMake,
        model: selectedModel
      })));
    default:
      return null;
  }
};
var FinancingPageRoot = function FinancingPageRoot() {
  var financingPageResponse = useFullPageData(PageNamesEnum.PAGE_NAME__FinancingPageRoot);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var pageContent;
  switch (financingPageResponse.slug) {
    case "financing":
      pageContent = /*#__PURE__*/React.createElement(FinanceLanding, financingPageResponse);
      break;
    case "financing-make":
      pageContent = /*#__PURE__*/React.createElement(FinancingMake, financingPageResponse);
      break;
    case "financing-make-model":
      pageContent = /*#__PURE__*/React.createElement(FinancingMakeModel, financingPageResponse);
      break;
    case "financing-full-banks":
      pageContent = /*#__PURE__*/React.createElement(FinanceBanks, financingPageResponse);
      break;
    default:
      pageContent = /*#__PURE__*/React.createElement("div", null, "Wrong Financing page");
  }
  return /*#__PURE__*/React.createElement(Layout, {
    headHideLinks: true,
    hasNavBar: true,
    authenticationMsg: true,
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    disableLoader: true,
    hideAppBanner: true,
    hasMobFooter: true,
    loading: true,
    mainClass: stl.mainFinancingClass,
    customStikeyButton: /*#__PURE__*/React.createElement("a", {
      className: ["redBtn"].join(" "),
      style: {
        width: "90%",
        padding: "20px",
        margin: "0 auto",
        height: "48px",
        marginTop: "7px",
        borderRadius: "4px"
      },
      href: createUrl("/autos")
    }, t("تصفح جميع السيارات ", {
      ns: "financing_page"
    }))
  }, pageContent);
};
export default FinancingPageRoot;